import { put, select, fork, take, race } from "redux-saga/effects";
import { dispatchGeneratorFunc } from "../helpers/helpers";
import {
  setShouldRequestInsights,
  setShouldRequestMonitoring,
} from "./requestSchedule";
import { snoozeEquipEvent } from "../../../utils/eventTracking";

export const SNOOZE_OPTIONS = {
  DAYS_1: { value: 1, label: "1 Day" },
  DAYS_7: { value: 7, label: "7 Days" },
  DAYS_30: { value: 30, label: "30 Days" },
  MONTHS_6: { value: 183, label: "6 Months" },
  MONTHS_12: { value: 365, label: "12 Months" },
  // TODO: Add a mechanism for INDEFINITE within synco
  // INDEFINITE: { value: -1, label: 'Indefinitely', warning: '(not recommended)' }
};

const INITIAL_STATE = {
  pending: true,
  complete: false,
  error: undefined,
};

export const SNOOZE_RULE_EQUIP = "bonfire/_BETA/triage/SNOOZE_RULE_EQUIP";
export const SNOOZE_RULE_EQUIP_REQUEST =
  "bonfire/_BETA/triage/SNOOZE_RULE_EQUIP_REQUEST";
export const SNOOZE_RULE_EQUIP_REQUEST_SUCCESS =
  "bonfire/_BETA/triage/SNOOZE_RULE_EQUIP_REQUEST_SUCCESS";
export const SNOOZE_RULE_EQUIP_REQUEST_FAIL =
  "bonfire/_BETA/triage/SNOOZE_RULE_EQUIP_REQUEST_FAIL";

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case SNOOZE_RULE_EQUIP_REQUEST:
      return {
        ...state,
        pending: true,
        complete: false,
        error: undefined,
      };
    case SNOOZE_RULE_EQUIP_REQUEST_SUCCESS:
      return {
        ...state,
        pending: false,
        complete: true,
        error: undefined,
      };
    case SNOOZE_RULE_EQUIP_REQUEST_FAIL:
      return {
        ...state,
        pending: false,
        complete: true,
        error: action.error,
      };
    default: {
      return state;
    }
  }
}

export const snoozeEquipRule = ({ equipRuleId, duration }) => ({
  type: SNOOZE_RULE_EQUIP,
  equipRuleId,
  duration,
});

export const snoozeEquipRules = ({ equipRuleIds, duration }) => ({
  type: SNOOZE_RULE_EQUIP,
  equipRuleIds,
  duration,
});

export const postSnoozeEquipRules = ({ equipRuleIds, duration, token }) => ({
  types: [
    SNOOZE_RULE_EQUIP_REQUEST,
    SNOOZE_RULE_EQUIP_REQUEST_SUCCESS,
    SNOOZE_RULE_EQUIP_REQUEST_FAIL,
  ],
  promise: (client) =>
    client.post("/synco/equipRule/snooze", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        duration,
        equipRuleIds,
      },
    }),
});

const getAuthUser = (state) => state.auth.user;
const getActiveSiteName = (state) => state.betaSelections.activeSite.label;

export function* snoozeEquipRuleFlow() {
  while (true) {
    const { duration, equipRuleIds } = yield take(SNOOZE_RULE_EQUIP);
    try {
      const user = yield select(getAuthUser);
      const siteName = yield select(getActiveSiteName);

      // Check that user has necessary permissions to make request
      if (!user.rolesRestriction) throw Error("Unable to authenticate user");

      // Validate that snooze duration has been given
      if (!duration) throw Error("No snooze duration given");

      // validate that at least one equipRuleId has been given
      if (!equipRuleIds) throw Error("No equipRuleIds given");

      yield fork(dispatchGeneratorFunc, postSnoozeEquipRules, {
        token: user.token,
        duration,
        equipRuleIds,
      });

      const { success, failure } = yield race({
        success: take(SNOOZE_RULE_EQUIP_REQUEST_SUCCESS),
        failure: take(SNOOZE_RULE_EQUIP_REQUEST_FAIL),
      });

      if (failure) {
        throw new Error("Failed to snooze ruleEquips");
      }
      if (success) {
        snoozeEquipEvent(siteName, duration, equipRuleIds, success.result);
        yield put(setShouldRequestInsights(true));
        yield put(setShouldRequestMonitoring(true));
      }
    } catch (err) {
      console.error(
        `Something went wrong attempting to snooze rule equip: ${err}`
      );
    }
  }
}
